import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PriceSuggestionResponse, PriceSuggestionState } from '../interfaces/price-suggestion';

const initialState: PriceSuggestionState = {
    suggestedPrice: null,
    loading: false,
    error: null,
};

const priceSuggestionSlice = createSlice({
    name: 'priceSuggestion',
    initialState,
    reducers: {
        priceSuggestionInitAction: (state) => {
            state.loading = true;
            state.error = null;
            state.suggestedPrice = null;
        },
        priceSuggestionSuccessAction: (state, action: PayloadAction<PriceSuggestionResponse>) => {
            state.loading = false;
            state.suggestedPrice = action.payload.suggestedPrice;
            state.error = null;
        },
        priceSuggestionFailureAction: (state, action: PayloadAction<{ errorCode: number; message?: string }>) => {
            state.loading = false;
            state.error = action.payload.message || `Error ${action.payload.errorCode}`;
        },
        clearPriceSuggestionAction: (state) => {
            state.suggestedPrice = null;
            state.loading = false;
            state.error = null;
        },
    },
});

export const {
    priceSuggestionInitAction,
    priceSuggestionSuccessAction,
    priceSuggestionFailureAction,
    clearPriceSuggestionAction,
} = priceSuggestionSlice.actions;

export default priceSuggestionSlice.reducer; 